package nl.volleyplanner.web

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.js
import kotlinx.browser.document
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.launch
import nl.volleyplanner.api.auth.AuthLevel
import nl.volleyplanner.api.client.VolleyplannerApiClient
import nl.volleyplanner.api.client.VolleyplannerApiFileUploadClient
import nl.volleyplanner.api.client.VolleyplannerApiPlannerClient
import nl.volleyplanner.web.base.WebPageController
import nl.volleyplanner.web.base.routing.PageRouter
import nl.volleyplanner.web.base.routing.RouteGuard
import nl.volleyplanner.web.controller.AdminController
import nl.volleyplanner.web.controller.VolleyplannerWebPageIndexController
import nl.volleyplanner.web.controller.authorization.LoginController
import nl.volleyplanner.web.controller.planner.PlannerIndexController
import nl.volleyplanner.web.controller.thuisprogramma.AnonymousThuisProgrammaController
import nl.volleyplanner.web.controller.userprofile.UserInviteController
import nl.volleyplanner.web.controller.userprofile.VerenigingBeheerController
import nl.volleyplanner.web.lib.getAnalytics
import nl.volleyplanner.web.service.WebUserAndOrganisationService
import org.w3c.dom.HTMLElement

object VolleyPlannerApplication : WebApplication {
    private val logger = Logger.getLogger("VolleyPlannerApplication")

    val volleyplannerRootApiClient = VolleyplannerApiClientFactory.createVolleyplannerApiRootClient(tokenLoader = VolleyPlannerWebAuthTokenLoader)

    @Deprecated("Listen to client through WebUserAndOrganisationService.selectedOrganisationState")
    val volleyplannerApiClient: VolleyplannerApiClient
        get() = WebUserAndOrganisationService.selectedOrganisationState.value!!.volleyplannerApiClient
    @Deprecated("Listen to client through WebUserAndOrganisationService.selectedOrganisationState")
    val volleyplannerApiPlannerClient: VolleyplannerApiPlannerClient
        get() = WebUserAndOrganisationService.selectedOrganisationState.value!!.volleyplannerApiPlannerClient
    @Deprecated("Listen to client through WebUserAndOrganisationService.selectedOrganisationState")
    val volleyplannerApiFileUploadClient: VolleyplannerApiFileUploadClient
        get() = WebUserAndOrganisationService.selectedOrganisationState.value!!.volleyplannerApiFileUploadClient

    private val headerMenuPages = listOf(
        PlannerIndexController(),
        AnonymousThuisProgrammaController()
    )

    override val rootPages = listOf(
        VolleyplannerWebPageIndexController(),
        AdminController(),
        VerenigingBeheerController(),
        UserInviteController()
    ) + headerMenuPages

    override val firebaseApp = Firebase.initialize(options = getFirebaseOptions())
    override val firebaseAnalytics = getAnalytics(firebaseApp.js)

    override fun getRouteGuards(webPageController: WebPageController) : List<RouteGuard> {
        return buildList {
            if (webPageController.requiredAuthLevel > AuthLevel.AnonymousPublic) {
                add(AuthRouteGuard(webPageController.requiredAuthLevel))
            }
        }
    }

    override fun getFirebaseOptions() = FirebaseOptions(
        applicationId = "1:875373469619:web:f3f825b36ffc89626975c6",
        apiKey = "AIzaSyCWHJ1uWhl0LPEu3lnZjqIDcl5ZpfVi6CI",
        projectId = "volleyplanner",
        authDomain = "volleyplanner.firebaseapp.com",
        storageBucket = "volleyplanner.appspot.com",
        gcmSenderId = "875373469619",
        gaTrackingId = "G-DNW2DPLBSZ"
    )

    override fun init() {
        val startupScope = CoroutineScope(Dispatchers.Main + SupervisorJob() + CoroutineManager.coroutineExceptionHandler)

        WebUserAndOrganisationService.initialize()

        val logoElement = document.getElementById("header-logo-container") as HTMLElement
        val headerNavigationElement = document.getElementById("header-navigation-container") as HTMLElement
        val userDropdownElement = document.getElementById("user-profile-dropdown-container") as HTMLElement

        startupScope.launch {
            HeaderLogoController().mount(logoElement)
            HeaderNavigationController(headerMenuPages).mount(headerNavigationElement)
            UserProfileDropdownController().mount(userDropdownElement)
        }

        logger.debug("Registering /login route")
        PageRouter.register("/login") {
            LoginController()
        }

        PageRouter.register("/thuisprogramma/:token", guards = listOf()) {
            AnonymousThuisProgrammaController()
        }

        PageRouter.register("/thuisprogramma/:token/:taskDay", guards = listOf()) {
            AnonymousThuisProgrammaController()
        }

        if (AppEnvironment.current == AppEnvironment.Development) {
            document.title = document.title + " - DEV"
        }
    }
}

fun main() {
    MainApp.init(VolleyPlannerApplication)
}
